<app-content-auth>
	<div class="right_login">
		<div class="content_form">
			<app-change-password></app-change-password>
		</div>
	</div>
</app-content-auth>
